



























import Vue, { PropType } from "vue";
import qs from "qs";

export interface saleCountrySelectProps {
  baseSaleUrl: string;
  countryList: any;
  initialCountryCode: string;
}

export interface saleCountrySelectData {
  countryCode: string;
  params: any;
}

export default Vue.extend({
  name: "vc-sale-country-select",
  props: {
    baseSaleUrl: {
      type: String as PropType<saleCountrySelectProps["baseSaleUrl"]>,
      default: ""
    },
    countryList: {
      type: Array as PropType<saleCountrySelectProps["countryList"]>,
      default: () => {}
    },
    initialCountryCode: {
      type: String as PropType<saleCountrySelectProps["initialCountryCode"]>,
      default: ""
    }
  },
  data(): saleCountrySelectData {
    return {
      countryCode: this.initialCountryCode,
      params: qs.parse(window.location.search.replace("?", ""))
    };
  },
  computed: {
    firstCountryList(): Object[] {
      return this.countryList.filter(function(country: any) {
        if (country.display_list_priority == 1) return true;
      });
    },
    secondCountryList(): Object[] {
      return this.countryList.filter(function(country: any) {
        if (country.display_list_priority == 2) return true;
      });
    }
  },
  methods: {
    changeCountryCode() {
      let urlParams = qs.parse(window.location.search.replace("?", ""));
      urlParams["countryCode"] = this.countryCode;
      const replaceUrl = this.baseSaleUrl + "?" + qs.stringify(urlParams);
      history.replaceState(null, "", replaceUrl);
      window.location.reload();
    }
  }
});
